// src/pages/SkillDetailPage.tsx
//
// Reforma UX §6.7 + §10.2: o detalhe de skill virou MODAL sobre a lista.
// /skills/:id é mantida como DEEP-LINK — este wrapper renderiza a SkillsPage
// com o modal de detalhe aberto (não quebra links externos). Fechar o modal
// navega de volta pra /skills.

import { useParams } from 'react-router-dom';
import { SkillsPage } from './SkillsPage';

export function SkillDetailPage() {
  const { id } = useParams<{ id: string }>();
  return <SkillsPage detailId={id} />;
}
